import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import { ErrorBoundary } from 'wsm-error-boundary';
import loadShift from '../utils/loadShift';

import DataMapper from '../components/DataMapper';
import LegacyTracking from '../components/LegacyTracking';

let timeout;

const hasAnEventMappingConfiguration = (mapping) =>
	typeof Object.values(mapping).find(
		(val) => typeof val.event !== 'undefined'
	) !== 'undefined';
export class WidgetContainer extends React.Component {
	componentDidMount() {
		window.DDC = window.DDC || {};
		window.DDC.WidgetData = window.DDC.WidgetData || {};
		window.DDC.WidgetData['ws-tagging'] =
			window.DDC.WidgetData['ws-tagging'] || {};
		window.DDC.WidgetData['ws-tagging'].mapping = this.props.mapping;
		window.dispatchEvent(new Event('ws-tagging-ready'));
	}

	componentWillUnmount() {
		clearTimeout(timeout); // added to pass a unit test but also makes sure setState doesn't run when component unmounted
	}

	render() {
		loadShift(this.props.legacyConfigurations);

		return (
			<ErrorBoundary newRelicPageAction="ws-tagging error boundary">
				<div data-testid="Widget">
					{hasAnEventMappingConfiguration(this.props.mapping) && (
						<DataMapper mapping={this.props.mapping} />
					)}
					{this.props.legacyConfigurations?.length > 0 && (
						<LegacyTracking
							legacyConfigurations={
								this.props.legacyConfigurations
							}
						/>
					)}
				</div>
			</ErrorBoundary>
		);
	}
}

WidgetContainer.propTypes = {
	legacyConfigurations: PropTypes.objectOf(PropTypes.object),
	mapping: PropTypes.objectOf(PropTypes.object)
};

const mapStateToProps = (state) => {
	return {
		mapping: state.mapping,
		legacyConfigurations: state.legacyConfigurations,
		flags: state.flags
	};
};

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
